export const environment = {
  name: "staging",
  clientUrl: 'https://crm.k8s.findl.lu/',
  apiUrl: 'https://api.k8s.findl.lu/crm/',
  issuer: 'https://auth.k8s.findl.lu/realms/atoz',
  matomoSiteId: 5,
  sentryDsn: "https://3311927c69a3516c3a99f7cc6275a041@o4506942806425600.ingest.us.sentry.io/4507746832809984",
  sentryTracePropagationTargetRegex: '^https:\/\/api\\.k8s\\.findl\\.lu\/crm'
};
